"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const dependencies_1 = require("./dependencies");
/** @description makes a color a certain percentage lighter than it was before, functioning like the lightness parameter of scss scale (https://sass-lang.com/documentation/modules/color#scale)
 * To adjust lightness by a fixed amount, use lighten and darken instead.
 *
 * @param {string} color Six digit hex code beginning with #. Examples: #ff0000, #FFFFFF, #b37399.
 * @param {number} amount Number between -100 and 100.
 * - Amount of 50 will scale the lightness 50% of the way towards white.
 * - Amount of 100 will always return white, #FFFFFF. Amount greater than 100 is functionally equivalent to 100.
 * - Amount of -50 will scale the lightness 50% of the way towards black.
 * - Amount of -100 will always return black, #000000. Amount less than -100 is functionally equivalent to -100.
 *
 * @return {string} Six digit hex code beginning with #. Examples: #ff0000, #FFFFFF, #b37399.
 */
function scaleLightness(color, amount) {
    const originalColor = new dependencies_1.TinyColor(color);
    // If we are scaling by amount = 0, there is no change.
    if (amount === 0) {
        return originalColor.toString();
    }
    // Amount greater than 100 is functionally equivalent to 100.
    if (amount > 100) {
        amount = 100;
    }
    // Amount less than -100 is functionally equivalent to -100.
    if (amount < -100) {
        amount = -100;
    }
    // Get lightness of original color via HSL (Hue, Saturation, Lightness)
    const originalColorHsl = originalColor.toHsl();
    const originalLightness = originalColorHsl.l;
    // If amount is positive, scale towards lightness of white (1), otherwise scale towards lightness of black (0).
    const scaleTowards = amount > 0 ? 1 : 0;
    const scalePercentage = Math.abs(amount / 100);
    // Calculate adjustment
    const adjustment = (scaleTowards - originalLightness) * scalePercentage;
    const adjustedLightness = originalLightness + adjustment;
    // Mixing the color with white or black is equivalent to scaling lightness.
    return new dependencies_1.TinyColor({
        h: originalColorHsl.h,
        s: originalColorHsl.s,
        l: adjustedLightness,
    }).toHexString();
}
exports.default = scaleLightness;
//# sourceMappingURL=ScaleLightness.js.map